import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Platform from '@app/components/Landing/Platform'
import ActionButton from '@app/components/ui/buttons/ActionButton'
import StateLabel from '@app/components/shared/StateLabel'
import Logo from '@app/components/shared/Logo'
import Friendship from '@app/components/shared/StateLabel/Friendship'
import { LandingPart } from '@app/components/shared/students/LandingPart'
import { Student } from '@app/models/users'
import classnames from 'classnames'

class Start extends Component {
  constructor(props) {
    super(props)
    this.handleStart = this.handleStart.bind(this)
  }

  handleStart(_) {
    const { boundStudentActions } = this.props
    boundStudentActions.participate({ tour: 'preparatory' })
  }

  render() {
    const { student, global, participate: { starting } } = this.props

    const classes = classnames(
      'page', 'student-tasks-page',
      'student-tasks-page--landing'
    )

    return (
      <Fragment>
        <div className={classes}>
          <div className="student-tasks-page__inner">
            <div className="student-tasks-page__title">
              <div className="student-tasks-page__left">
                <Logo theme="left" event={global.event} />
              </div>
              <div className="student-tasks-page__center" />
            </div>
            <div className="student-tasks-page__content-wrapper">
              <Friendship event={global.event} />
              <div className="student-tasks-page__panel text-center">
                <h1 className="student-tasks-page__status text-center xl mt-1 mb-4">
                  { I18n.t('students.at_trial_tour.status3') }
                </h1>
                <ActionButton
                  className="btn btn--red btn--lg mt-1 mb-2"
                  onClick={this.handleStart}
                  disabled={starting}
                  loading={starting}>
                  { I18n.t('students.at_trial_tour.start2') }
                </ActionButton>
              </div>
            </div>
            <Platform className="pt-1" theme="white" />
            <div className="student-tasks-page__state_label">
              <StateLabel event={global.event} />
            </div>
          </div>
        </div>
        <LandingPart student={student} global={global} />
      </Fragment>
    )
  }
}

Start.propTypes = {
  boundStudentActions: PropTypes.object.isRequired,
  student: PropTypes.instanceOf(Student).isRequired,
  participate: PropTypes.object.isRequired
}

export default Start
